import React from "react";
import FooterNav from "../components/Layout/FooterNav";

const Policy = () => {
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "'Roboto', sans-serif",
        color: "#ffffff",
        background: "linear-gradient(135deg, #0047AB, #00A550)",
        borderRadius: "10px",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
        lineHeight: "1.8",
        maxWidth: "1200px",
        margin: "20px auto",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          marginBottom: "30px",
          color: "#00FFCC",
          fontSize: "2.5rem",
          textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
        }}
      >
        Privacy Policy
      </h1>
      <p
        style={{
          fontSize: "1rem",
          background: "rgba(0, 0, 0, 0.2)",
          padding: "10px 15px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        This privacy policy sets out how <b>ABANAIJAMADE ECART LTD</b> uses and protects any
        information that you provide at <b>Ariariamarketplace.com.ng</b> when you use this website.
        <b>Ariariamarketplace.com.ng</b> is committed to ensuring that your privacy is protected.
        Should we ask you to provide certain information by which you can be identified when using
        this website, you can be assured that it will only be used in accordance with this privacy
        statement. <b>Ariariamarketplace.com.ng</b> may change this policy from time to time by
        updating this page. You should check this page periodically to ensure that you are updated
        and happy with any changes.
      </p>

      <h2
        style={{
          color: "#00FFCC",
          marginBottom: "15px",
          textTransform: "uppercase",
          borderBottom: "2px solid #00FFCC",
          paddingBottom: "5px",
        }}
      >
        What we collect
      </h2>
      <ul
        style={{
          listStyleType: "circle",
          marginLeft: "20px",
          color: "#FFFFFF",
        }}
      >
        <li>Name</li>
        <li>Contact information including email address</li>
        <li>Demographic information such as postcode, preferences, and interests</li>
        <li>Other information relevant to customer surveys and/or offers</li>
      </ul>

      <h2
        style={{
          color: "#00FFCC",
          marginBottom: "15px",
          textTransform: "uppercase",
          borderBottom: "2px solid #00FFCC",
          paddingBottom: "5px",
        }}
      >
        What we do with the information we gather
      </h2>
      <ul
        style={{
          listStyleType: "square",
          marginLeft: "20px",
          color: "#FFFFFF",
        }}
      >
        <li>Internal record keeping.</li>
        <li>We may use the information to improve our products and services.</li>
        <li>
          We may periodically send promotional emails about new products, special offers, or other
          information which we think you may find interesting using the email address which you
          have provided.
        </li>
        <li>
          From time to time, we may also use your information to contact you for market research
          purposes. We may contact you by email, phone, fax, or mail.
        </li>
        <li>We may use the information to customize the website according to your interests.</li>
      </ul>

      <h2
        style={{
          color: "#00FFCC",
          marginBottom: "15px",
          textTransform: "uppercase",
          borderBottom: "2px solid #00FFCC",
          paddingBottom: "5px",
        }}
      >
        Security
      </h2>
      <p
        style={{
          fontSize: "1rem",
          background: "rgba(0, 0, 0, 0.2)",
          padding: "10px 15px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        We are committed to ensuring that your information is secured. In order to prevent
        unauthorized access or disclosure, we have put in place suitable physical, electronic, and
        managerial procedures to safeguard and secure the information we collect online.
      </p>

      <h2
        style={{
          color: "#00FFCC",
          marginBottom: "15px",
          textTransform: "uppercase",
          borderBottom: "2px solid #00FFCC",
          paddingBottom: "5px",
        }}
      >
        How we use cookies
      </h2>
      <p
        style={{
          fontSize: "1rem",
          background: "rgba(0, 0, 0, 0.2)",
          padding: "10px 15px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        A cookie is a small file which asks permission to be placed on your computer's hard drive.
        Once you agree, the file is added and the cookie helps analyze web traffic or lets you know
        when you visit a particular site. Cookies allow web applications to respond to you as an
        individual. The web application can tailor its operations to your needs, likes, and dislikes
        by gathering and remembering information about your preferences.
      </p>

      <h2
        style={{
          color: "#00FFCC",
          marginBottom: "15px",
          textTransform: "uppercase",
          borderBottom: "2px solid #00FFCC",
          paddingBottom: "5px",
        }}
      >
        Links to other websites
      </h2>
      <p
        style={{
          fontSize: "1rem",
          background: "rgba(0, 0, 0, 0.2)",
          padding: "10px 15px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        Our website may contain links to other websites of interest. However, once you have used
        these links to leave our site, you should note that we do not have any control over that
        other website. Therefore, we cannot be responsible for the protection and privacy of any
        information which you provide whilst visiting such sites, and such sites are not governed
        by this privacy statement. You should exercise caution and look at the privacy statement
        applicable to the website in question.
      </p>

      <h2
        style={{
          color: "#00FFCC",
          marginBottom: "15px",
          textTransform: "uppercase",
          borderBottom: "2px solid #00FFCC",
          paddingBottom: "5px",
        }}
      >
        Controlling your personal information
      </h2>
      <p
        style={{
          fontSize: "1rem",
          background: "rgba(0, 0, 0, 0.2)",
          padding: "10px 15px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        You may choose to restrict the collection or use of your personal information in the
        following ways:
      </p>
      <ul
        style={{
          listStyleType: "disc",
          marginLeft: "20px",
          color: "#FFFFFF",
        }}
      >
        <li>
          Whenever you are asked to fill in a form on the website, look for the box that you can
          click to indicate that you do not want the information to be used by anybody for direct
          marketing purposes.
        </li>
        <li>
          If you have previously agreed to us using your personal information for direct marketing
          purposes, you may change your mind at any time by writing to us at{" "}
          <a
            href="mailto:info@ariariamarketplace.com.ng"
            style={{ color: "#FF3B3B", textDecoration: "underline" }}
          >
            info@ariariamarketplace.com.ng
          </a>
          .
        </li>
      </ul>
      <FooterNav />
    </div>
  );
};

export default Policy;
